import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useOccContext } from '../../../context/occ/hooks/use-occ-context';
import { Dropdown } from '../../../subcomponents/form/input/dropdown/dropdown';
import { getFilterLabel } from '../../../utils/filters/get-filter-label';
const b = bemClassBuilder('v-single-filter-dropdown');
export const SingleFilterDropdown = observer(props => {
    const { id, options, onClick, filterKey, displayText, config } = props;
    const [selectedValue, setSelected] = useState(options[0].value);
    useEffect(() => {
        const selectedOption = options.find(o => o.selected);
        if (selectedOption) {
            setSelected(selectedOption.value);
        }
    }, [options]);
    const handleChange = (newValue) => {
        setSelected(newValue);
        onClick(newValue);
    };
    const dropdownOptions = useDropdownOptions(options, filterKey, displayText.allOptionLabel);
    return (_jsx(Dropdown, { id: id, className: b.block(), options: dropdownOptions, value: selectedValue, onChangeValue: handleChange, noSearchResultsFoundMessage: displayText.noSearchResultsFoundMessage, enableSearch: config.enableSearch }));
});
SingleFilterDropdown.displayName = 'SingleFilterDropdown';
const useDropdownOptions = (options, filterKey, allOptionLabel) => {
    const { config, displayText, i18n } = useOccContext();
    return options.map(option => (Object.assign(Object.assign({}, option), { text: getFilterLabel(filterKey, option.value, config, displayText, i18n, allOptionLabel) })));
};
